import { userPaths } from 'routes/constants/userPaths';
import { isUserAuthenticated } from 'routes/guards/session';

import { Navigate, Outlet } from 'react-router-dom';

import EndUserSupportFab from 'components/endUserSupportFab';

import { useHydrateEndUserDashboardState } from 'hooks/useHydrateEndUserDashboardState';
import { useRefreshEndUserStateOnMyAccountExit } from 'hooks/useRefreshEndUserStateOnMyAccountExit';

/**
 * Employee private routes. On unauthenticated access, send to sign-in without
 * storing a deep-link — after logout / session expiry the next login always
 * lands on Expenses via the journey resolver (not the blocked page).
 */
const UserPrivateRoute = () => {
  useHydrateEndUserDashboardState();
  useRefreshEndUserStateOnMyAccountExit();

  if (!isUserAuthenticated()) {
    return <Navigate to={userPaths.signIn} replace />;
  }

  return (
    <>
      <Outlet />
      <EndUserSupportFab />
    </>
  );
};

export default UserPrivateRoute;
